module.exports = __webpack_public_path__ + "img/goods-share.e4f62e5e.png";